import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import tblWebsiteDemoVideo from '../../../Interfaces/DataBase/tblWebsiteDemoVideo';

interface initialDemoVideoProps {
  encryptedDemoVideoList: tblWebsiteDemoVideo[];
  selectedDemoVideo?: tblWebsiteDemoVideo;
}

export const initialDemoVideoValue: initialDemoVideoProps = {
  encryptedDemoVideoList: [],
};

const demoVideoSetSlice = createSlice({
  name: 'demoVideo',
  initialState: initialDemoVideoValue,
  reducers: {
    setEncryptedDemoVideo: (
      state,
      action: PayloadAction<tblWebsiteDemoVideo[]>
    ) => {
      state.encryptedDemoVideoList = action.payload;
    },
    getEncryptedDemoVideoByUrl: (state, action: PayloadAction<string>) => {
      state.selectedDemoVideo = state.encryptedDemoVideoList.find(
        (x) => x.PageUrl === action.payload
      );
    },
  },
});

export const { setEncryptedDemoVideo, getEncryptedDemoVideoByUrl } =
  demoVideoSetSlice.actions;

export default demoVideoSetSlice.reducer;
